import { render, staticRenderFns } from "./ManageRoleCustomPermission.vue?vue&type=template&id=31b413ff&scoped=true"
import script from "./ManageRoleCustomPermission.vue?vue&type=script&lang=js"
export * from "./ManageRoleCustomPermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b413ff",
  null
  
)

export default component.exports